import createAPIRequest from "../helpers/createAPIRequest";
import store from "../store/index";
//--------------------
// edit combat action
//--------------------
export default async function useEditCombatMarker(this_marker) {
  return new Promise((resolve, reject) => {
    //--------------
    // access store
    //--------------
    const this_store = store;
    //--------------------
    // set api call parms
    //--------------------
    let parm_slug = "";

    if (this_marker.slug != "") {
      parm_slug = this_marker.slug;
    }

    let request_parms = {
      endpoint: "api/v1/combat-markers/",
      slug: parm_slug,
    };
    //--------------------
    // create api request
    //--------------------
    let request = createAPIRequest(request_parms);
    //---------------
    // set api parms
    //---------------
    let api_parms = {
      api_request: request,
      payload: this_marker,
    };
    //----------
    // call api
    //----------
    this_store
      .dispatch("combat/editCombatMarker", api_parms)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
